import { render, staticRenderFns } from "./insuranceFeeRule.vue?vue&type=template&id=3282cea8&scoped=true&"
import script from "./insuranceFeeRule.vue?vue&type=script&lang=js&"
export * from "./insuranceFeeRule.vue?vue&type=script&lang=js&"
import style0 from "./insuranceFeeRule.vue?vue&type=style&index=0&id=3282cea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282cea8",
  null
  
)

export default component.exports